import Papa from 'papaparse';

export const TOOLS_CSV_COLUMNS = [
    'tool_name',
    'description',
    'parameters',
    'input_schema',
    'output_schema',
    'supports_read',
    'supports_write',
    'supports_delete',
];

const BOOLEAN_FIELDS = ['supports_read', 'supports_write', 'supports_delete'];
const SCHEMA_FIELDS = ['input_schema', 'output_schema'];

const normalizeBoolean = (value) => {
    if (typeof value !== 'string') {
        return value;
    }
    const lowered = value.trim().toLowerCase();
    if (['yes', 'true'].includes(lowered)) {
        return '1';
    }
    if (['no', 'false'].includes(lowered)) {
        return '0';
    }
    return value.trim();
};

export const validateToolRow = (row) => {
    const fieldErrors = {};

    const toolName = typeof row.tool_name === 'string' ? row.tool_name.trim() : '';
    if (!toolName) {
        fieldErrors.tool_name = 'Tool name is required';
    } else if (toolName.length > 255) {
        fieldErrors.tool_name = 'Max 255 characters';
    }

    BOOLEAN_FIELDS.forEach((field) => {
        if (!['0', '1'].includes(row[field])) {
            fieldErrors[field] = 'Must be 0, 1, Yes or No';
        }
    });

    SCHEMA_FIELDS.forEach((field) => {
        const value = row[field];
        if (value && typeof value === 'string' && value.trim()) {
            try {
                JSON.parse(value);
            } catch {
                fieldErrors[field] = 'Must be valid JSON';
            }
        }
    });

    return fieldErrors;
};

export const parseToolsCsvFile = (file) => {
    return new Promise((resolve) => {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: 'greedy',
            complete: (result) => {
                const fileErrors = [];

                if (result.errors && result.errors.length > 0) {
                    result.errors.slice(0, 3).forEach((e) => {
                        fileErrors.push(`Row ${e.row + 1}: ${e.message}`);
                    });
                }

                const headers = result.meta.fields ?? [];
                const missingHeaders = TOOLS_CSV_COLUMNS.filter((c) => !headers.includes(c));
                if (missingHeaders.length > 0) {
                    fileErrors.push(`Missing required column(s): ${missingHeaders.join(', ')}`);
                }

                if (fileErrors.length > 0) {
                    resolve({ rows: [], fileErrors });
                    return;
                }

                const rows = result.data.map((raw, index) => {
                    const row = {
                        _key: index,
                        clientRowId: index,
                        tool_name: (raw.tool_name ?? '').trim(),
                        description: raw.description ?? '',
                        parameters: raw.parameters ?? '',
                        input_schema: raw.input_schema ?? '',
                        output_schema: raw.output_schema ?? '',
                        supports_read: normalizeBoolean(raw.supports_read),
                        supports_write: normalizeBoolean(raw.supports_write),
                        supports_delete: normalizeBoolean(raw.supports_delete),
                    };
                    row._errors = validateToolRow(row);
                    return row;
                });

                if (rows.length === 0) {
                    resolve({ rows: [], fileErrors: ['No data rows found in the file'] });
                    return;
                }

                resolve({ rows, fileErrors: [] });
            },
            error: (error) => {
                resolve({ rows: [], fileErrors: [`Failed to read file: ${error.message}`] });
            },
        });
    });
};
